module.exports = __webpack_public_path__ + "img/account2.da6c927b.png";